import { useState, useEffect } from "react";
import { tokens } from "../tokens";

export function useBreakpoint() {
  const [width, setWidth] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 1280
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return {
    isMobile:  width <= tokens.breakpoints.mobile,
    isTablet:  width >  tokens.breakpoints.mobile && width <= tokens.breakpoints.tablet,
    isDesktop: width >  tokens.breakpoints.tablet,
    width,
  };
}